import { ComponentProps } from 'react';
import { Fieldset } from '../../Inputs/Fieldset/Fieldset';

export function RadioGroup(props: ComponentProps<typeof Fieldset>): React.JSX.Element {
    return <Fieldset role="radiogroup" {...props} />;
}
